import { globalSingleton } from './chunk-N7SZ66QO.js';

// src/evidence/provider-ids.generated.json
var provider_ids_generated_default = {
  ids: [
    "across",
    "alchemy",
    "ankr",
    "antelope_rpc",
    "aptos_rest",
    "arkham",
    "blockchair",
    "blockchair_api",
    "blockscan",
    "blockscout",
    "blocksec",
    "blockstream",
    "bob_gateway",
    "chainflip",
    "chainlink_ccip",
    "codeslaw",
    "coingecko",
    "coingecko_web",
    "coinmarketcap",
    "cosmos_directory",
    "cosmos_lcd",
    "cowswap",
    "debridge_dln",
    "defillama",
    "dexscreener",
    "etherscan",
    "etherscan_family",
    "etherscan_scan",
    "evm_rpc",
    "fastnear",
    "fourbyte",
    "garden",
    "goldrush",
    "helius",
    "hop",
    "hyperlane",
    "hyperliquid",
    "infura",
    "layerzero",
    "mayachain",
    "mayan",
    "mempool_space",
    "metasleuth",
    "moralis",
    "moralis_explorer",
    "moralis_official",
    "near_intents",
    "near_rpc",
    "openchain_4byte",
    "polymarket_clob",
    "polymarket_data",
    "polymarket_gamma",
    "quicknode",
    "relay",
    "routescan",
    "scanscope",
    "solana_rpc",
    "solscan",
    "sourcify",
    "starknet_rpc",
    "sui_graphql",
    "tatum",
    "thegraph",
    "thorchain",
    "toncenter",
    "trongrid",
    "tronscan",
    "whatsabi",
    "wormhole",
    "xmrchain",
    "xrpl_rpc",
    "xrpscan",
    "zapper",
    "zerox_scope_legacy",
    "zksync_explorer"
  ],
  names: [
    "arkham intelligence",
    "arkhamintelligence",
    "zerox_scope_legacy",
    "cosmos_directory",
    "etherscan_family",
    "moralis_explorer",
    "moralis_official",
    "polymarket_gamma",
    "4byte.directory",
    "coin market cap",
    "openchain_4byte",
    "polymarket_clob",
    "polymarket_data",
    "zksync_explorer",
    "blockchair_api",
    "etherscan_scan",
    "coingecko_web",
    "coinmarketcap",
    "mempool_space",
    "antelope_rpc",
    "starknet_rpc",
    "blockdaemon",
    "blockstream",
    "dexscreener",
    "sui_graphql",
    "aptos_rest",
    "blockchair",
    "blockscout",
    "coin gecko",
    "cosmos_lcd",
    "metasleuth",
    "quick node",
    "solana_rpc",
    "blockscan",
    "chainbase",
    "coingecko",
    "defillama",
    "etherscan",
    "openchain",
    "quicknode",
    "routescan",
    "scanscope",
    "the graph",
    "toncenter",
    "0x scope",
    "bitquery",
    "blocksec",
    "codeslaw",
    "covalent",
    "fastnear",
    "fourbyte",
    "goldrush",
    "near_rpc",
    "nodereal",
    "sourcify",
    "tenderly",
    "thegraph",
    "trongrid",
    "tronscan",
    "whatsabi",
    "xmrchain",
    "xrpl_rpc",
    "0xscope",
    "alchemy",
    "evm_rpc",
    "moralis",
    "solscan",
    "xrpscan",
    "arkham",
    "helius",
    "infura",
    "nansen",
    "zapper",
    "tatum",
    "ankr"
  ],
  first_party: [
    "behavioural_heuristics",
    "bridges_registry",
    "bytecode",
    "catalog_import",
    "dust_campaign_detector",
    "erc4337_safe",
    "feedback",
    "forensic_account_type",
    "forensic_address_poisoning",
    "forensic_airdrop_farmer",
    "forensic_consolidation_wallet",
    "forensic_counterfeit_token",
    "forensic_deposit_address",
    "forensic_drainer",
    "forensic_ens_name",
    "forensic_exposure",
    "forensic_factory_instance",
    "forensic_funding_source",
    "forensic_pass_through",
    "forensic_protocol_usage",
    "forensic_scam_deployer",
    "forensic_spam_token",
    "forensic_trading_bot",
    "inferred",
    "internal",
    "manual",
    "operator_curated",
    "protocol_registry"
  ]
};

// src/evidence/privacy.ts
var DATA_SOURCE_LABEL = "Authe data";
var ids = new Set(provider_ids_generated_default.ids);
var firstParty = new Set(provider_ids_generated_default.first_party);
var names = [...provider_ids_generated_default.names, "bubblemaps", "elliptic", "chainalysis", "trm labs", "trmlabs", "esplora", "arkm.com"];
var escape = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
var namePattern = new RegExp(`(?<![a-z0-9])(?:@|ProviderId\\.)?(?:${names.map(escape).join("|")})(?:[_-](?:explorer|official|web|api))?(?![a-z0-9])`, "gi");
var nameCheck = new RegExp(namePattern.source, "i");
var hasName = (s) => nameCheck.test(s);
function privateMediaUrl(value) {
  if (!/^https?:\/\//i.test(value)) return false;
  if (hasName(value)) return true;
  try {
    const url = new URL(value);
    return /^entities-logos\.s3(?:[.-][a-z0-9-]+)?\.amazonaws\.com$/i.test(url.hostname) || /^s3(?:[.-][a-z0-9-]+)?\.amazonaws\.com$/i.test(url.hostname) && url.pathname.startsWith("/entities-logos/");
  } catch {
    return false;
  }
}
function mediaField(key) {
  const normalized = key.replace(/([a-z0-9])([A-Z])/g, "$1_$2").toLowerCase();
  return /(?:^|_)(?:logo|icon|thumbnail|image)(?:_(?:s3_)?(?:url|uri))?$/.test(normalized);
}
var privacy = globalSingleton("evidence/privacy", () => ({ customerAudience: false }));
function enableCustomerDataPrivacy() {
  privacy.customerAudience = true;
}
function customerData(value) {
  return privacy.customerAudience ? redactCustomerData(value) : value;
}
function customerText(value) {
  return privacy.customerAudience ? privateSourceText(value) : value;
}
function privateSourceText(text) {
  return text.replace(/asserted by provider\s+([^\s(]+)/gi, (line, id) => firstParty.has(id) ? line : "attributed by Authe").replace(/https?:\/\/[^\s<>"')\]]+/gi, (url) => hasName(url) ? "data service" : url).replace(namePattern, DATA_SOURCE_LABEL);
}
function customerTextEdit(original, next) {
  if (!privacy.customerAudience) return next;
  const visible = privateSourceText(original);
  if (visible === next) return original;
  const pattern = new RegExp(`asserted by provider\\s+[^\\s(]+|https?:\\/\\/[^\\s<>"')\\]]+|${namePattern.source}`, "gi");
  const spans = [];
  let offset = 0;
  for (const match of original.matchAll(pattern)) {
    const replacement = privateSourceText(match[0]);
    if (replacement === match[0]) continue;
    const start2 = match.index + offset;
    spans.push({ rawStart: match.index, rawEnd: match.index + match[0].length, start: start2, end: start2 + replacement.length });
    offset += replacement.length - match[0].length;
  }
  let start = 0;
  while (start < visible.length && start < next.length && visible[start] === next[start]) start++;
  let end = visible.length, nextEnd = next.length;
  while (end > start && nextEnd > start && visible[end - 1] === next[nextEnd - 1]) {
    end--;
    nextEnd--;
  }
  for (const span of spans) {
    if (start > span.start && start < span.end) start = span.start;
    if (end > span.start && end < span.end) end = span.end;
  }
  const rawPosition = (position) => {
    let delta = 0;
    for (const span of spans) {
      if (position <= span.start) break;
      delta = span.rawEnd - span.end;
    }
    return position + delta;
  };
  return original.slice(0, rawPosition(start)) + next.slice(start, next.length - (visible.length - end)) + original.slice(rawPosition(end));
}
function privateSourceLabel(value) {
  if (value == null || value === "") return void 0;
  const text = String(value);
  const id = text.toLowerCase().replace(/^provider:|^source_system=/, "");
  if (["whatsabi", "openchain", "openchain_4byte"].includes(id)) return id === "whatsabi" ? "bytecode_analysis" : "4byte";
  return ids.has(id) || hasName(text) || id === "aggregate" || id === "aggregated from multiple sources" ? DATA_SOURCE_LABEL : text;
}
var identity = /* @__PURE__ */ new Set(["provider", "provider_id", "providerId", "provider_name", "providerName", "upstream_provider", "vendor", "vendor_id"]);
var origins = /* @__PURE__ */ new Set(["source", "source_id", "sourceId", "source_name", "sourceLabel", "source_label", "data_source", "origin", "abi_source", "price_source", "upstream_source", "claimSource", "contributors"]);
var prose = /* @__PURE__ */ new Set(["explanation", "explain", "reasons", "reason", "message", "error", "error_message", "detail", "details", "warning", "warnings", "failure_reason", "last_error", "problems", "save_problems", "enabled_nodes", "disabled_nodes", "decision_summary", "decision_reason", "incident_reported_by", "reported_by"]);
var privateRefs = /* @__PURE__ */ new Set(["raw_payload_ref", "provider_url", "provider_endpoint"]);
var sourceLinks = /* @__PURE__ */ new Set(["source_url", "sourceUrl"]);
function privateEvidenceSource(source) {
  if (!source) return false;
  if (source.visibility === "internal") return true;
  if (typeof source.id === "string" && firstParty.has(source.id)) return false;
  return source.kind === "provider" || typeof source.id === "string" && privateSourceLabel(source.id) !== source.id;
}
function redactCustomerData(value) {
  const visit = (item, key = "", parentPrivate = false, incident = false) => {
    if (typeof item === "string") {
      if (identity.has(key)) return privateSourceLabel(item);
      if (origins.has(key) || key === "sources" || key === "providers" || /_(?:source|source_id|provider|provider_id)$/.test(key)) return privateSourceLabel(item);
      if (prose.has(key)) return privateSourceText(item);
      if (incident && ["headline", "summary", "note", "confidence_basis"].includes(key)) return privateSourceText(item);
      if (key === "description" && /\b(?:imported|sourced|fetched|provided|supplied|attributed|asserted)\b/i.test(item)) return privateSourceText(item);
      if (mediaField(key) && privateMediaUrl(item)) return null;
      if (["payload", "metadata", "body", "evidence"].includes(key) && /^[\[{]/.test(item.trim())) {
        try {
          return JSON.stringify(visit(JSON.parse(item), key, parentPrivate, incident));
        } catch {
        }
      }
      return item;
    }
    if (Array.isArray(item)) return item.filter((v) => {
      if (key === "origins" && typeof v?.path === "string" && v.path.startsWith("base_overrides.third_party.")) return false;
      if (["references", "citations"].includes(key) && v && typeof v === "object" && [v.url, v.label, v.handle].some((s) => typeof s === "string" && hasName(s))) return false;
      return true;
    }).map((v) => visit(v, key, parentPrivate, incident));
    if (!item || typeof item !== "object" || Object.getPrototypeOf(item) !== Object.prototype) return item;
    const row = item;
    const incidentContext = incident || "incident_id" in row || "source_report_id" in row || "occurred_on" in row && "id" in row;
    if (row.kind === "url" && typeof row.value === "string" && privateMediaUrl(row.value)) return null;
    const source = row.source && typeof row.source === "object" ? row.source : void 0;
    const hidden = ["source", "sources", "provider", "providers"].includes(key) && privateEvidenceSource(row);
    const evidencePrivate = privateEvidenceSource(source);
    const out = {};
    for (const [field, val] of Object.entries(row)) {
      if (["base_tables", "base_overrides"].includes(key) && field === "third_party" || field.startsWith("base_overrides.third_party.")) continue;
      if (field === "traceback") continue;
      if (field === "source" && "target" in row) {
        out[field] = val;
        continue;
      }
      if (key === "source" && field === "url" && typeof val === "string" && hasName(val)) continue;
      if ((sourceLinks.has(field) || field.endsWith("_source_url")) && (hidden || evidencePrivate || typeof val === "string" && hasName(val) || Object.entries(row).some(([k, v]) => (identity.has(k) || origins.has(k) && !(k === "source" && "target" in row)) && typeof v === "string" && privateSourceLabel(v) !== v))) continue;
      if (privateRefs.has(field) || (hidden || parentPrivate) && ["id", "name", "url", "external_id", "raw_payload"].includes(field)) continue;
      if (hidden && field === "kind") {
        out[field] = "aggregate";
        continue;
      }
      if (hidden && field === "visibility") {
        out[field] = "external";
        continue;
      }
      if ((evidencePrivate || hidden) && ["metadata", "signals", "context", "reasons"].includes(field)) {
        out[field] = field === "context" && val && typeof val === "object" ? Object.fromEntries(Object.entries(val).filter(([k]) => k === "scope" || k === "scope_tier")) : field === "reasons" ? [] : {};
        continue;
      }
      out[field] = visit(val, field, field === "source" && evidencePrivate, incidentContext);
    }
    return out;
  };
  return visit(value);
}

export { DATA_SOURCE_LABEL, customerData, customerText, customerTextEdit, enableCustomerDataPrivacy, privateSourceLabel, privateSourceText, redactCustomerData };
//# sourceMappingURL=chunk-YQKWOCI5.js.map
//# sourceMappingURL=chunk-YQKWOCI5.js.map